import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createCommentVNode as _createCommentVNode, vModelSelect as _vModelSelect, resolveDirective as _resolveDirective, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "splash-container" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h2", { class: "text-center text-white mb-4" }, "New Applicant Registration", -1)
const _hoisted_3 = {
  key: 0,
  class: "form-group text-white"
}
const _hoisted_4 = /*#__PURE__*/_createElementVNode("label", {
  for: "accountEmail",
  class: "form-label"
}, " Please enter your e-mail address. This will be the e-mail address you will use to login to the system. ", -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("em", { class: "fw-bold" }, "USE A PERSONAL E-MAIL ACCOUNT. DO NOT USE AN E-MAIL ACCOUNT ISSUED BY YOUR DISTRICT.", -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-exclamation-circle me-1" }, null, -1)
const _hoisted_8 = {
  key: 0,
  class: "alert alert-danger rounded mt-1 p-2"
}
const _hoisted_9 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-exclamation-circle me-1" }, null, -1)
const _hoisted_10 = /*#__PURE__*/_createTextVNode("That e-mail address is already in use. Please ")
const _hoisted_11 = /*#__PURE__*/_createTextVNode("login")
const _hoisted_12 = /*#__PURE__*/_createTextVNode(" to continue. ")
const _hoisted_13 = {
  key: 1,
  class: "form-group"
}
const _hoisted_14 = /*#__PURE__*/_createElementVNode("label", {
  for: "student",
  class: "form-label text-white"
}, [
  /*#__PURE__*/_createTextVNode(" Are you a senior (or recent graduate) of a "),
  /*#__PURE__*/_createElementVNode("i", { class: "fw-bold" }, "public"),
  /*#__PURE__*/_createTextVNode(" high-school in Arkansas? ")
], -1)
const _hoisted_15 = /*#__PURE__*/_createElementVNode("option", { value: 1 }, "Yes", -1)
const _hoisted_16 = /*#__PURE__*/_createElementVNode("option", { value: 0 }, "No", -1)
const _hoisted_17 = [
  _hoisted_15,
  _hoisted_16
]
const _hoisted_18 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-exclamation-circle me-1" }, null, -1)
const _hoisted_19 = {
  key: 2,
  class: "form-group"
}
const _hoisted_20 = {
  key: 0,
  class: "text-white"
}
const _hoisted_21 = {
  key: 1,
  class: "alert alert-danger rounded mt-1 p-2"
}
const _hoisted_22 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-exclamation-circle me-1" }, null, -1)
const _hoisted_23 = /*#__PURE__*/_createTextVNode(" The information you entered matched a student that already has an account established. You may attempt to use the ")
const _hoisted_24 = /*#__PURE__*/_createTextVNode("Forgot Password")
const _hoisted_25 = /*#__PURE__*/_createTextVNode(" link if you have forgotten the e-mail address with which you originally registered. ")
const _hoisted_26 = {
  key: 2,
  class: "alert alert-danger rounded mt-1 p-2"
}
const _hoisted_27 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-exclamation-circle me-1" }, null, -1)
const _hoisted_28 = /*#__PURE__*/_createTextVNode(" The information you entered either matched multiple student records or was an incomplete match on one or more records. Please contact ADHE for further assistance. ")
const _hoisted_29 = [
  _hoisted_27,
  _hoisted_28
]
const _hoisted_30 = {
  key: 3,
  class: "alert alert-danger rounded mt-1 p-2"
}
const _hoisted_31 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-exclamation-circle me-1" }, null, -1)
const _hoisted_32 = /*#__PURE__*/_createTextVNode(" Although you indicated, 'Yes', you are a senior (or recent graduate) of a public Arkansas high school, we could NOT find your information in the system. To proceed, please correct the information you have entered OR go back to the previous screen and select, 'No'. ")
const _hoisted_33 = [
  _hoisted_31,
  _hoisted_32
]
const _hoisted_34 = { class: "form-group mb-2" }
const _hoisted_35 = /*#__PURE__*/_createElementVNode("label", {
  for: "ssn",
  class: "form-label text-white"
}, "Social Security Number", -1)
const _hoisted_36 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-exclamation-circle me-1" }, null, -1)
const _hoisted_37 = { class: "form-group mb-2" }
const _hoisted_38 = /*#__PURE__*/_createElementVNode("label", {
  for: "first-name",
  class: "form-label text-white"
}, "First Name", -1)
const _hoisted_39 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-exclamation-circle me-1" }, null, -1)
const _hoisted_40 = { class: "form-group mb-2" }
const _hoisted_41 = /*#__PURE__*/_createElementVNode("label", {
  for: "last-name",
  class: "form-label text-white"
}, "Last Name", -1)
const _hoisted_42 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-exclamation-circle me-1" }, null, -1)
const _hoisted_43 = { class: "form-group" }
const _hoisted_44 = /*#__PURE__*/_createElementVNode("label", {
  for: "dob",
  class: "form-label text-white"
}, "Date of Birth", -1)
const _hoisted_45 = ["min", "max"]
const _hoisted_46 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-exclamation-circle me-1" }, null, -1)
const _hoisted_47 = {
  key: 3,
  class: "form-group text-white"
}
const _hoisted_48 = {
  key: 0,
  class: "alert alert-success rounded mt-1 p-2"
}
const _hoisted_49 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-exclamation-circle me-1" }, null, -1)
const _hoisted_50 = /*#__PURE__*/_createTextVNode(" The information you entered can be used to create a new applicant account. ")
const _hoisted_51 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_52 = /*#__PURE__*/_createTextVNode("Please enter the following fields. Then, click continue to proceed. ")
const _hoisted_53 = [
  _hoisted_49,
  _hoisted_50,
  _hoisted_51,
  _hoisted_52
]
const _hoisted_54 = {
  key: 1,
  class: "alert alert-success rounded mt-1 p-2"
}
const _hoisted_55 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-exclamation-circle me-1" }, null, -1)
const _hoisted_56 = /*#__PURE__*/_createTextVNode(" We found you! Please verify the district and school are correct to continue. ")
const _hoisted_57 = [
  _hoisted_55,
  _hoisted_56
]
const _hoisted_58 = {
  key: 2,
  class: "alert alert-warning rounded mt-1 p-2"
}
const _hoisted_59 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-exclamation-circle me-1" }, null, -1)
const _hoisted_60 = /*#__PURE__*/_createTextVNode(" Although you indicated, 'No', you are NOT a senior (or recent graduate) of a public Arkansas high school, we found a record in the system with the information you provided. If you choose to continue, we will link your new account to this record. ")
const _hoisted_61 = /*#__PURE__*/_createElementVNode("p", { class: "mt-2" }, "Please verify the district and school are correct to continue.", -1)
const _hoisted_62 = [
  _hoisted_59,
  _hoisted_60,
  _hoisted_61
]
const _hoisted_63 = {
  key: 3,
  class: "form-group mb-2"
}
const _hoisted_64 = /*#__PURE__*/_createElementVNode("label", {
  for: "linked-applicant-name",
  class: "form-label text-white"
}, "Name", -1)
const _hoisted_65 = { class: "form-group mb-2" }
const _hoisted_66 = /*#__PURE__*/_createElementVNode("label", {
  for: "new-applicant-district",
  class: "form-label text-white"
}, "District", -1)
const _hoisted_67 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-exclamation-circle me-1" }, null, -1)
const _hoisted_68 = { class: "form-group mb-2" }
const _hoisted_69 = /*#__PURE__*/_createElementVNode("label", {
  for: "new-applicant-school",
  class: "form-label text-white"
}, "School", -1)
const _hoisted_70 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-exclamation-circle me-1" }, null, -1)
const _hoisted_71 = {
  key: 4,
  class: "form-group text-white"
}
const _hoisted_72 = { class: "form-group mb-2" }
const _hoisted_73 = /*#__PURE__*/_createElementVNode("label", {
  for: "email",
  class: "form-label text-white disabled"
}, "Email Address", -1)
const _hoisted_74 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-exclamation-circle me-1" }, null, -1)
const _hoisted_75 = { class: "form-group mb-2" }
const _hoisted_76 = /*#__PURE__*/_createElementVNode("label", {
  for: "password",
  class: "form-label text-white"
}, "Password", -1)
const _hoisted_77 = /*#__PURE__*/_createElementVNode("label", {
  for: "confirm-password",
  class: "form-label text-white"
}, "Confirm Password", -1)
const _hoisted_78 = { class: "card" }
const _hoisted_79 = { class: "card-body" }
const _hoisted_80 = {
  key: 5,
  class: "form-group text-white"
}
const _hoisted_81 = {
  key: 0,
  class: "alert alert-success rounded mt-1 p-2 fs-4"
}
const _hoisted_82 = /*#__PURE__*/_createElementVNode("i", { class: "fad fa-fw fa-check-circle me-1" }, null, -1)
const _hoisted_83 = /*#__PURE__*/_createTextVNode("Your new account has been created. You will receive an email with a confirmation link that you must follow before you will be able to login. Please check your spam and/or junk folders for the Account Confirmation email if not found in your Inbox. ")
const _hoisted_84 = { class: "d-grid gap-2 my-3" }
const _hoisted_85 = /*#__PURE__*/_createTextVNode("Log in to SAMS")
const _hoisted_86 = {
  key: 1,
  class: "alert alert-danger rounded mt-1 p-2"
}
const _hoisted_87 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-exclamation-circle me-1" }, null, -1)
const _hoisted_88 = /*#__PURE__*/_createTextVNode("An error occurred while creating the new account. Please contact ADHE for assistance. ")
const _hoisted_89 = [
  _hoisted_87,
  _hoisted_88
]
const _hoisted_90 = { class: "d-flex justify-content-evenly" }
const _hoisted_91 = /*#__PURE__*/_createTextVNode("Register ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_school_district_drop_down = _resolveComponent("school-district-drop-down")!
  const _component_high_school_drop_down = _resolveComponent("high-school-drop-down")!
  const _component_password_feedback = _resolveComponent("password-feedback")!
  const _component_activity_button = _resolveComponent("activity-button")!
  const _directive_maska = _resolveDirective("maska")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    (_ctx.currentStep === 'email-validation')
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _hoisted_4,
          _hoisted_5,
          _hoisted_6,
          _withDirectives(_createElementVNode("input", {
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_ctx.state.applicant.username = $event)),
            type: "email",
            class: "form-control",
            id: "accountEmail",
            onFocusin: _cache[1] || (_cache[1] = ($event: any) => (_ctx.state.emailAvailable = undefined))
          }, null, 544), [
            [_vModelText, _ctx.state.applicant.username]
          ]),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.v$.applicant.username.$errors, (error) => {
            return (_openBlock(), _createElementBlock("div", {
              class: "alert alert-danger rounded mt-1 p-2",
              key: error.$uid
            }, [
              _hoisted_7,
              _createTextVNode(_toDisplayString(error.$message), 1)
            ]))
          }), 128)),
          (_ctx.state.emailAvailable === false)
            ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                _hoisted_9,
                _hoisted_10,
                _createVNode(_component_router_link, { to: "Public/Login" }, {
                  default: _withCtx(() => [
                    _hoisted_11
                  ]),
                  _: 1
                }),
                _hoisted_12
              ]))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true),
    (_ctx.currentStep === 'applicant-school-status')
      ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
          _hoisted_14,
          _withDirectives(_createElementVNode("select", {
            id: "student",
            class: "form-select",
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.state.publicSchoolStudent = $event))
          }, _hoisted_17, 512), [
            [_vModelSelect, _ctx.state.publicSchoolStudent]
          ]),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.v$2.publicSchoolStudent.$errors, (error) => {
            return (_openBlock(), _createElementBlock("div", {
              class: "alert alert-danger rounded mt-1 p-2",
              key: error.$uid
            }, [
              _hoisted_18,
              _createTextVNode(_toDisplayString(error.$message), 1)
            ]))
          }), 128))
        ]))
      : _createCommentVNode("", true),
    (_ctx.currentStep === 'applicant-link')
      ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
          (_ctx.state.publicSchoolStudent === 1)
            ? (_openBlock(), _createElementBlock("p", _hoisted_20, "Please enter the information below exactly as your Arkansas Public School District has entered it on your transcript."))
            : _createCommentVNode("", true),
          (_ctx.state.applicant.status === _ctx.AccountAssociationStatus.ApplicantAccountAlreadyExists)
            ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
                _hoisted_22,
                _hoisted_23,
                _createVNode(_component_router_link, { to: { name: 'Public/Login/ForgotEmail' } }, {
                  default: _withCtx(() => [
                    _hoisted_24
                  ]),
                  _: 1
                }),
                _hoisted_25
              ]))
            : _createCommentVNode("", true),
          (_ctx.state.applicant.status === _ctx.AccountAssociationStatus.NameMatchExactFails)
            ? (_openBlock(), _createElementBlock("div", _hoisted_26, _hoisted_29))
            : _createCommentVNode("", true),
          (((_ctx.state.publicSchoolStudent === 1) && (_ctx.state.applicant.status === _ctx.AccountAssociationStatus.CanCreateNewApplicantAndAccount)))
            ? (_openBlock(), _createElementBlock("div", _hoisted_30, _hoisted_33))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_34, [
            _hoisted_35,
            _withDirectives(_createElementVNode("input", {
              class: "form-control",
              type: "text",
              id: "ssn",
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.state.applicant.ssn = $event)),
              onInput: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.actions.limitInput && _ctx.actions.limitInput(...args))),
              placeholder: "###-##-####"
            }, null, 544), [
              [_vModelText, _ctx.state.applicant.ssn],
              [_directive_maska, '###-##-####']
            ])
          ]),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.v$3.applicant.ssn.$errors, (error) => {
            return (_openBlock(), _createElementBlock("div", {
              class: "alert alert-danger rounded mt-1 p-2",
              key: error.$uid
            }, [
              _hoisted_36,
              _createTextVNode(_toDisplayString(error.$message), 1)
            ]))
          }), 128)),
          _createElementVNode("div", _hoisted_37, [
            _hoisted_38,
            _withDirectives(_createElementVNode("input", {
              class: "form-control",
              type: "text",
              id: "first-name",
              "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (_ctx.state.applicant.firstName = $event))
            }, null, 512), [
              [_vModelText, _ctx.state.applicant.firstName]
            ])
          ]),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.v$3.applicant.firstName.$errors, (error) => {
            return (_openBlock(), _createElementBlock("div", {
              class: "alert alert-danger rounded mt-1 p-2",
              key: error.$uid
            }, [
              _hoisted_39,
              _createTextVNode(_toDisplayString(error.$message), 1)
            ]))
          }), 128)),
          _createElementVNode("div", _hoisted_40, [
            _hoisted_41,
            _withDirectives(_createElementVNode("input", {
              class: "form-control",
              type: "text",
              id: "last-name",
              "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (_ctx.state.applicant.lastName = $event))
            }, null, 512), [
              [_vModelText, _ctx.state.applicant.lastName]
            ])
          ]),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.v$3.applicant.lastName.$errors, (error) => {
            return (_openBlock(), _createElementBlock("div", {
              class: "alert alert-danger rounded mt-1 p-2",
              key: error.$uid
            }, [
              _hoisted_42,
              _createTextVNode(_toDisplayString(error.$message), 1)
            ]))
          }), 128)),
          _createElementVNode("div", _hoisted_43, [
            _hoisted_44,
            _withDirectives(_createElementVNode("input", {
              class: "form-control",
              type: "date",
              id: "dob",
              "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => (_ctx.state.applicant.dob = $event)),
              min: _ctx.minDOB,
              max: _ctx.maxDOB
            }, null, 8, _hoisted_45), [
              [_vModelText, _ctx.state.applicant.dob]
            ])
          ]),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.v$3.applicant.dob.$errors, (error) => {
            return (_openBlock(), _createElementBlock("div", {
              class: "alert alert-danger rounded mt-1 p-2",
              key: error.$uid
            }, [
              _hoisted_46,
              _createTextVNode(_toDisplayString(error.$message), 1)
            ]))
          }), 128))
        ]))
      : _createCommentVNode("", true),
    (_ctx.currentStep === 'applicant-link-results')
      ? (_openBlock(), _createElementBlock("div", _hoisted_47, [
          (((_ctx.currentStep === 'applicant-link-results') && (_ctx.state.publicSchoolStudent === 0
      && _ctx.state.applicant.status === _ctx.AccountAssociationStatus.CanCreateNewApplicantAndAccount)))
            ? (_openBlock(), _createElementBlock("div", _hoisted_48, _hoisted_53))
            : _createCommentVNode("", true),
          (((_ctx.currentStep === 'applicant-link-results') && (_ctx.state.publicSchoolStudent === 1
      && _ctx.state.applicant.status === _ctx.AccountAssociationStatus.CanLinkToApplicant)))
            ? (_openBlock(), _createElementBlock("div", _hoisted_54, _hoisted_57))
            : _createCommentVNode("", true),
          (((_ctx.state.publicSchoolStudent === 0) && (_ctx.state.applicant.status === _ctx.AccountAssociationStatus.CanLinkToApplicant)))
            ? (_openBlock(), _createElementBlock("div", _hoisted_58, _hoisted_62))
            : _createCommentVNode("", true),
          (((_ctx.currentStep === 'applicant-link-results') && (_ctx.state.publicSchoolStudent === 1
      && _ctx.state.applicant.status === _ctx.AccountAssociationStatus.CanLinkToApplicant)))
            ? (_openBlock(), _createElementBlock("div", _hoisted_63, [
                _hoisted_64,
                _withDirectives(_createElementVNode("input", {
                  class: "form-control",
                  readonly: "",
                  type: "text",
                  id: "linked-applicant-name",
                  "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => (_ctx.state.applicant.name = $event))
                }, null, 512), [
                  [_vModelText, _ctx.state.applicant.name]
                ])
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_65, [
            _hoisted_66,
            _createVNode(_component_school_district_drop_down, {
              id: "new-applicant-district",
              modelValue: _ctx.state.applicant.districtId,
              "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => (_ctx.state.applicant.districtId = $event)),
              "allow-null-selection": true
            }, null, 8, ["modelValue"])
          ]),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.v$4.applicant.districtId.$errors, (error) => {
            return (_openBlock(), _createElementBlock("div", {
              class: "alert alert-danger rounded mt-1 p-2",
              key: error.$uid
            }, [
              _hoisted_67,
              _createTextVNode(_toDisplayString(error.$message), 1)
            ]))
          }), 128)),
          _createElementVNode("div", _hoisted_68, [
            _hoisted_69,
            _createVNode(_component_high_school_drop_down, {
              id: "new-applicant-district",
              modelValue: _ctx.state.applicant.highSchoolId,
              "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => (_ctx.state.applicant.highSchoolId = $event)),
              "district-id": _ctx.state.applicant.districtId,
              "show-inactive-schools": false,
              "allow-null-selection": true
            }, null, 8, ["modelValue", "district-id"])
          ]),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.v$4.applicant.highSchoolId.$errors, (error) => {
            return (_openBlock(), _createElementBlock("div", {
              class: "alert alert-danger rounded mt-1 p-2",
              key: error.$uid
            }, [
              _hoisted_70,
              _createTextVNode(_toDisplayString(error.$message), 1)
            ]))
          }), 128))
        ]))
      : _createCommentVNode("", true),
    (_ctx.currentStep === 'finalize')
      ? (_openBlock(), _createElementBlock("div", _hoisted_71, [
          _createElementVNode("div", _hoisted_72, [
            _hoisted_73,
            _withDirectives(_createElementVNode("input", {
              class: "form-control",
              readonly: "",
              type: "text",
              id: "email",
              "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => (_ctx.state.applicant.username = $event))
            }, null, 512), [
              [_vModelText, _ctx.state.applicant.username]
            ])
          ]),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.v$5.applicant.username.$errors, (error) => {
            return (_openBlock(), _createElementBlock("div", {
              class: "alert alert-danger rounded mt-1 p-2",
              key: error.$uid
            }, [
              _hoisted_74,
              _createTextVNode(_toDisplayString(error.$message), 1)
            ]))
          }), 128)),
          _createElementVNode("div", _hoisted_75, [
            _hoisted_76,
            _withDirectives(_createElementVNode("input", {
              class: "form-control",
              type: "password",
              id: "password",
              "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => (_ctx.state.applicant.password = $event))
            }, null, 512), [
              [_vModelText, _ctx.state.applicant.password]
            ]),
            _hoisted_77,
            _withDirectives(_createElementVNode("input", {
              class: "form-control",
              type: "password",
              id: "confirm-password",
              "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => (_ctx.state.applicant.confirmPassword = $event))
            }, null, 512), [
              [_vModelText, _ctx.state.applicant.confirmPassword]
            ])
          ]),
          _createElementVNode("div", _hoisted_78, [
            _createElementVNode("div", _hoisted_79, [
              _createVNode(_component_password_feedback, {
                password: (_ctx.state.applicant.password || ''),
                "confirm-password": (_ctx.state.applicant.confirmPassword || ''),
                modelValue: _ctx.state.passwordIsValid,
                "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => (_ctx.state.passwordIsValid = $event)),
                "cannot-match-sequence": _ctx.cannotMatches
              }, null, 8, ["password", "confirm-password", "modelValue", "cannot-match-sequence"])
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.currentStep === 'finalize-results')
      ? (_openBlock(), _createElementBlock("div", _hoisted_80, [
          (_ctx.state.accountCreated === true)
            ? (_openBlock(), _createElementBlock("div", _hoisted_81, [
                _hoisted_82,
                _hoisted_83,
                _createElementVNode("div", _hoisted_84, [
                  _createVNode(_component_router_link, {
                    class: "btn btn-success mx-auto",
                    to: "Public/Login"
                  }, {
                    default: _withCtx(() => [
                      _hoisted_85
                    ]),
                    _: 1
                  })
                ])
              ]))
            : _createCommentVNode("", true),
          (_ctx.state.accountCreated === false)
            ? (_openBlock(), _createElementBlock("div", _hoisted_86, _hoisted_89))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_90, [
      ((_ctx.state.step > 0) && (_ctx.state.step < _ctx.steps.length - 1))
        ? (_openBlock(), _createElementBlock("button", {
            key: 0,
            class: "btn btn-success btn-lg mt-2",
            name: "back",
            onClick: _cache[15] || (_cache[15] = 
//@ts-ignore
(...args) => (_ctx.actions.back && _ctx.actions.back(...args)))
          }, "Back "))
        : _createCommentVNode("", true),
      (_ctx.state.step < _ctx.steps.length - 2)
        ? (_openBlock(), _createElementBlock("button", {
            key: 1,
            class: "btn btn-success btn-lg mt-2",
            name: "continue",
            onClick: _cache[16] || (_cache[16] = 
//@ts-ignore
(...args) => (_ctx.actions.next && _ctx.actions.next(...args)))
          }, "Continue "))
        : _createCommentVNode("", true),
      (_ctx.currentStep === 'finalize' && _ctx.state.passwordIsValid)
        ? (_openBlock(), _createBlock(_component_activity_button, {
            key: 2,
            class: "btn btn-success btn-lg mt-2",
            name: "register",
            clickHandler: _ctx.actions.register
          }, {
            default: _withCtx(() => [
              _hoisted_91
            ]),
            _: 1
          }, 8, ["clickHandler"]))
        : _createCommentVNode("", true)
    ])
  ]))
}